import { render, staticRenderFns } from "./BrakepadsClassroom2.vue?vue&type=template&id=713bf0f8&scoped=true"
import script from "./BrakepadsClassroom2.vue?vue&type=script&lang=js"
export * from "./BrakepadsClassroom2.vue?vue&type=script&lang=js"
import style0 from "./BrakepadsClassroom2.vue?vue&type=style&index=0&id=713bf0f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713bf0f8",
  null
  
)

export default component.exports